
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"72","height":"22"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(1 1)"}},[_c('path',{attrs:{"stroke":"#EF7D01","d":"M23 3.5h40","stroke-linecap":"square","stroke-dasharray":"2"}}),_c('path',{attrs:{"stroke":"#292929","d":"M66.5 7a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"}}),_c('path',{attrs:{"stroke":"#EF7D01","d":"M10 16.5h40","stroke-linecap":"square","stroke-dasharray":"2"}}),_c('circle',{attrs:{"cx":"3.5","cy":"16.5","r":"3.5","stroke":"#292929"}})])]);
        };
      

        module.exports = {
          
          render: render,
        };
      


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/difference.svg
// module id = FfOI
// module chunks = 1